"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForeignEntityDetailsSchema = exports.UpdateCompanyIdentificationSchema = exports.companyTypeSchema = exports.companyIdentifierSchema = exports.FOREIGN_IDENTIFICATION_NUMBER_MESSAGE = exports.FOREIGN_IDENTIFICATION_NUMBER_REGEX = exports.AUSTRALIAN_COMPANY_TYPES = exports.FOREIGN_COMPANY_TYPE = void 0;
const yup = __importStar(require("yup"));
exports.FOREIGN_COMPANY_TYPE = "Foreign Company";
exports.AUSTRALIAN_COMPANY_TYPES = ["Private Company", "Public Company", "Trustee Company", "SMSF"];
exports.FOREIGN_IDENTIFICATION_NUMBER_REGEX = /^[A-Za-z0-9][A-Za-z0-9 ./-]{0,29}$/;
exports.FOREIGN_IDENTIFICATION_NUMBER_MESSAGE = "Identification number must be up to 30 letters, digits, spaces, '.', '/' or '-'";
/** Required 9-digit ACN for an Australian entity; an optional free-form identification number for a foreign one. */
const companyIdentifierSchema = (acnMessage, requiredMessage) => yup
    .string()
    .trim()
    .when("isForeignEntity", {
    is: true,
    then: (schema) => schema.matches(exports.FOREIGN_IDENTIFICATION_NUMBER_REGEX, {
        message: exports.FOREIGN_IDENTIFICATION_NUMBER_MESSAGE,
        excludeEmptyString: true,
    }),
    otherwise: (schema) => schema.required(requiredMessage).matches(/^\d{9}$/, acnMessage),
});
exports.companyIdentifierSchema = companyIdentifierSchema;
/** Foreign entities carry the foreign company type; Australian ones never do. */
const companyTypeSchema = (requiredMessage) => yup
    .string()
    .trim()
    .required(requiredMessage)
    .when("isForeignEntity", {
    is: true,
    then: (schema) => schema.oneOf([exports.FOREIGN_COMPANY_TYPE], `Company Type must be ${exports.FOREIGN_COMPANY_TYPE}`),
    otherwise: (schema) => schema.oneOf(exports.AUSTRALIAN_COMPANY_TYPES, `Company Type must be one of the following values: ${exports.AUSTRALIAN_COMPANY_TYPES.join(", ")}`),
});
exports.companyTypeSchema = companyTypeSchema;
exports.UpdateCompanyIdentificationSchema = yup.object().shape({
    isForeignEntity: yup.boolean().oneOf([true], "Only marking a company as a foreign entity is supported").required(),
    acn: (0, exports.companyIdentifierSchema)("ACN should be exact 9 digits long", "Please enter the ACN"),
});
exports.ForeignEntityDetailsSchema = yup.object().shape({
    isForeignEntity: yup.boolean(),
    entityName: yup.string().trim().required("Please enter the entity name").max(255),
    acn: (0, exports.companyIdentifierSchema)("ACN should be exact 9 digits long"),
});
//# sourceMappingURL=CompanyIdentification.js.map